/**
 * The programme/product lockup: the CSNDC programme name above the product
 * name.
 *
 * Text rather than the Lenovo mark. The corporate signature is a red 3:1 frame
 * that the brand rules will not let you scale below 150px or crowd, and in a
 * 240px rail that made it the loudest thing on the page — louder than the
 * project you are actually working in. The lockup already carries the public
 * shell's top bar, so all three shells now read the same.
 */
export function BrandLockup({ productClassName }: { productClassName?: string }) {
  return (
    <>
      <span className="brand-lockup-org">CSNDC</span>
      <span
        className={productClassName ? `brand-lockup-name ${productClassName}` : 'brand-lockup-name'}
      >
        Crash Dump Diagnostics
      </span>
    </>
  );
}
